<div class="rp-container">
  <div class="card rp-card">
    <div class="card-body">
      <h4 class="text-center mb-4">Reset Password</h4>
      <form [formGroup]="resetPasswordFg" (ngSubmit)="resetPassword()">
        <div class="form-group">
          <label>Password</label>
          <input type="text" class="form-control" placeholder="Password" formControlName="password">
          <small class="text-danger" *ngIf="password?.invalid && password?.touched || isSubmitted">
            <span *ngIf="password?.errors?.required">Password is required.</span>
            <span *ngIf="password?.errors?.minlength">Password must be at least 6 characters long.</span>
          </small>
        </div>
        <div class="form-group">
          <label>Confirm Password</label>
          <input type="text" class="form-control" placeholder="Confirm Password" formControlName="confirmPassword">
          <small class="text-danger" *ngIf="confirmPassword?.invalid && confirmPassword?.touched || isSubmitted">
            <span *ngIf="confirmPassword?.errors?.required">Confirm Password is required.</span>
            <span *ngIf="resetPasswordFg?.errors?.mismatch && confirmPassword?.touched">Password does not match.</span>
          </small>
        </div>
        <button type="button" class="btn btn-primary btn-block"
                [disabled]="isLoading" (click)="resetPassword()">
          <i *ngIf="isLoading" class="fa fa-spinner fa-spin"></i> Save</button>
      </form>
    </div>
  </div>
</div>
